<template>
  <header
    ref="header"
    class="header"
    :class="{'header--active': menuActive}">
    <div class="header__labels">
      <RouterLink
        class="hidden-mbl logo"
        to="/">
        <span>NewActon Pavilion</span>
        <span class="subtitle">
          Peppers Gallery Hotel, Commercial &amp; Retail Precinct
        </span>
      </RouterLink>
      <p
        v-if="$route.meta.showInHeader || $route.meta.showInHeader === undefined"
        class="current-page">
        {{ $route.name }}
      </p>
    </div>
    <div
      class="header__hamburger click"
      :class="{'header__hamburger--active': menuActive}"
      @click="menuActive = !menuActive">
      <div id="hamburger">
        <div class="header__hamburger-line"></div>
      </div>
    </div>
    <div
      v-if="sectionItems.length > 0"
      class="header__sub">
      <ul class="header__sub-sections">
        <li
          v-for="(sectionItem, key) in sectionItems"
          :key="`sectionItem${key}`"
          :class="{'active': activeSectionItem === key}">
          <button
            class="bold click"
            @click="scrollTo(sectionItem.toLowerCase().trim(), key)">
            {{ sectionItem }}
          </button>
        </li>
      </ul>
    </div>
    <div
      v-if="menuActive"
      class="header__menu">
      <div
        v-if="sectionItems && sectionItems.length"
        class="mobile-subnav">
        <ul
          class="header__menu-sections-mbl">
          <li
            v-for="(sectionItem, key) in sectionItems"
            :key="`sectionItem${key}`">
            <button
              class="bold click"
              @click="scrollTo(sectionItem.toLowerCase().trim())">
              {{ sectionItem }}
            </button>
          </li>
        </ul>
      </div>
      <ul
        v-if="menuItems"
        class="header__menu-main">
        <li
          v-for="(menuItem, key) in menuItems"
          :key="`menuItem${key}`">
          <RouterLink
            :to="menuItem.path"
            class="bold">
            {{ menuItem.meta.navPrepend }} {{ menuItem.name }}
          </RouterLink>
        </li>
      </ul>
      <!-- <ul
        v-if="sectionItems"
        class="header__menu-sections">
        <li
          v-for="(sectionItem, key) in sectionItems"
          :key="`sectionItem${key}`">
          <button
            class="bold click"
            @click="scrollTo(sectionItem.toLowerCase().trim())">
            {{ sectionItem }}
          </button>
        </li>
      </ul>-->
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  components: {},
  data() {
    return {
      menuActive: false,
      sectionItems: [],
      activeSectionItem: 0,
      rows: null
    }
  },
  computed: {
    menuItems: function() {
      return this.$router.options.routes.filter(route => {
        if (route.meta.showInMenu) return true
      })
    }
  },
  watch: {
    $route(to, from) {
      if (this.menuActive) {
        this.menuActive = false
      }
      this.rows = null
    }
  },
  mounted() {
    this.$root.$on('sectionsList', (sections) => {
      this.sectionItems = sections
      this.activeSectionItem = 0

      setTimeout(() => {
        this.rows = document.querySelectorAll('.row')

        window.addEventListener('scroll', ($evt) => {
          if (this.rows) {
            if (this.rows[this.activeSectionItem] && (this.rows[this.activeSectionItem].getBoundingClientRect().top - 160) < 0) {
              this.activeSectionItem = this.activeSectionItem < this.rows.length - 1 ? this.activeSectionItem + 1 : this.rows.length - 1
            }

            if (this.rows[this.activeSectionItem] && (this.rows[this.activeSectionItem].getBoundingClientRect().top - 160) > 0) {
              this.activeSectionItem = this.activeSectionItem > 0 ? this.activeSectionItem - 1 : 0
            }
          }

        })
      }, 300)
    })

    this.$nextTick(() => {
      this.resizeHandler()
    })
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler(e) {
      document.body.style.setProperty('--header-height', this.$refs.header.offsetHeight + "px");
    },
    toggleMenu: function() {
      if (this.menuActive === false) {
        this.menuActive = true
      }
    },
    scrollTo(target, key) {
      // get target element and header height for offset
      var element = document.getElementById(target)
      var offset = document.querySelector('.header').offsetHeight

      // get body height to reference against element
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = element.getBoundingClientRect().top

      // calculate element scroll position
      const elementPosition = elementRect - bodyRect

      // subtract header offset height
      const offsetPosition = elementPosition - offset

      // check if element exists
      if (element) {
        // close menu
        this.menuActive = false

        // scroll to elements position
        window.scrollTo({
          top: offsetPosition,
          behavior: 'auto'
        })

        this.activeSectionItem = key
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden-br {
  display: none;
  @include desktop {
    display: block;
  }
}

.header {
  width: 100%;
  position: fixed;
  display: flex;
  align-content: center;
  background: $color--base;
  padding: $gutter--base $gutter--base;
  backface-visibility: hidden;
  z-index: 3;

  @include mobile {
    padding: $gutter--base-mbl;
  }

  &__labels {
    display: flex;
    column-gap: 2rem;
    justify-content: space-between;
    width: 100%;

    @include mobile {
      column-gap: 0;
    }

    .current-page,
    .logo {
      line-height: 1;
      color: $color--white;
      font-size: 2.25rem;
      font-weight: bold;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;

      @include desktop {
        font-size: 2.25rem;
      }

      @include mobile {
        font-size: 2rem;
      }

      span {
        display: inline-block;
      }
    }


    .current-page {
      flex-shrink: 0;
      padding-right: 1.5rem;

      @include mobile {
        display: none;
      }
    }

    .subtitle {
      font-size: 1.25rem;
      line-height: 1;

      @include mobile {
        font-size: 1rem;
      }
    }
  }

  &__hamburger {
    width: rem(78);
    height: rem(50);
    margin: 0 0 0 auto;
    position: relative;

    @include mobile {
      width: rem(43);
      height: rem(30);
    }

    &::before,
    &::after {
      content: '';
      background: $color--white;
      position: absolute;
      width: 100%;
      height: 9px;
      transform-origin: center;

      @include mobile {
        height: 5px;
      }
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }

    &--active {
      &::before {
        transform: rotate(45deg);
        top: 50%;
        margin-top: -4.5px;

        @include mobile {
          margin-top: -2.5px;
        }
      }

      &::after {
        transform: rotate(-45deg);
        bottom: 50%;
        margin-bottom: -4.5px;

        @include mobile {
          margin-bottom: -2.5px;
        }
      }

      .header__hamburger-line {
        opacity: 0;
      }
    }
  }

  &__hamburger-line {
    position: absolute;
    background: $color--white;
    height: 9px;
    width: 100%;
    top: 50%;
    margin-top: -4.5px;

    @include mobile {
      height: 5px;
      margin-top: -2.5px;
    }
  }

  &__sub {
    width: 100%;
    position: absolute;
    top: 108px;
    background-color: #000;
    padding: 0 0 10px 0;

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 0 $gutter--base 0 0;

        &.active {
          a, button {
            color: $color--white;
          }
        }

        a, button {
          @include button-resets;
          color: $color--grey;
          @include text-large;

          &.router-link-exact-active {
            color: $color--white;
          }
        }
      }
    }

    @include mobile {
      display: none;
      top: 64px;
      padding: 0 0 4px 0;
      ul {
        flex-wrap: wrap;

        li {
          a, button {
            font-size: $font-size--body-mbl !important;
            line-height: 1.5 !important;
          }
        }
      }
    }
  }

  &__menu {
    user-select: none;
    position: fixed;
    top: var(--header-height, 90px);
    left: 0;
    right: 0;
    bottom: 0;
    background: $color--base;
    padding: 0 $gutter--base;
    backface-visibility: hidden;
    display: flex;

    @include mobile {
      flex-direction: column;
      top: var(--header-height,80px);
      padding: 0 15px;
    }

    ul {
      padding-top: $gutter--base;

      &.header__menu-main {
        margin-right: rem(80);
        min-width: 29.5vw;

        @include mobile {
          margin-right: 0;
        }

        @include desktop {
          min-width: rem(363);
        }

        > li:nth-child(2) {
          margin-bottom: rem(40);

          @include mobile {
            margin-bottom: rem(20);
          }
        }
      }

      &.header__menu-sections {
        a,
        button {
          color: $color--grey;
        }

        @include mobile {
          display: none;
        }
      }
    }

    button {
      @include button-resets;
    }

    a, button {
      color: $color--grey;
      @include text-large;

      &.router-link-exact-active {
        color: $color--white;
      }
    }

    .mobile-subnav {
      display: none;

      .current-page {
        font-size: $font-size--lrg-mbl;
        line-height: $line-height--lrg-mbl;
      }

      .header__menu-sections-mbl {
        padding-top: 0;
        margin-bottom: $padding--base-mbl;

        a,
        button {
          color: $color--grey;
        }
      }

      @include mobile {
        display: block;
      }
    }
  }
}
</style>
